<script lang="jsx">
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ClientForm from '../../components/ClientForm'

const CreateClient = ({ context, client, storeGroups }) => (
  <div class="card">
    <header>
      <h2>Create Client</h2>
    </header>
    <ClientForm context={context} client={client} storeGroups={storeGroups} buttonName="Create" action={() => context.createClient()} />
  </div>
)

export default {
  computed: {
    ...mapGetters('clients', [
      'selectedClient',
      'userMailTemplates',
      'userActions',
      'clientLoading',
      'clientError',
      'saving',
      'updating',
      'clientSuccess',
      'saveSuccess',
      'updateSuccess',
      'paymentOrganizations',
      'showPaymentOrgForm',
      'get',
    ]),
    ...mapGetters('storeGroups', ['storeGroups']),
  },
  created() {
    this.initClient()
  },
  methods: {
    ...mapMutations('clients', ['update', 'resetClient', 'addTier', 'removeTier']),
    ...mapActions('clients', ['initClient', 'createClient', 'setUserMailTemplate', 'addNewPaymentOrganization']),
  },

  render() {
    return (
      <div class="page">
        <CreateClient context={this} client={this.selectedClient} storeGroups={this.storeGroups} />
      </div>
    )
  },
}
</script>
